"use client";

import type { JSX } from "react";
import { LinkButton } from "@repo/ui/link-button";

import { ActionLink } from "@/components/common/actions/actions.component";
import { getI18nString } from "@/lib/utils";
import type { PagebuilderType } from "@/lib/types";

type SectionActions = NonNullable<
  PagebuilderType<"cardLinksSections">["section"]
>["actions"];

interface CardLinksSectionsActionsProps {
  actions: SectionActions;
}

// "use client" is load-bearing: LinkButton asChild + Radix Slot spreads
// an onClick across the SSR boundary, which breaks hydration when
// rendered inside a server component.
export function CardLinksSectionsActions({
  actions,
}: CardLinksSectionsActionsProps): JSX.Element | null {
  if (!actions || actions.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-4">
      {actions.map(
        (action) =>
          action?.to && (
            <ActionLink key={action._id} actionTo={action.to}>
              <LinkButton
                asChild
                underline
                variant="primary"
                size="md"
                className="desktop:typography-component-md-medium"
              >
                <span>{getI18nString(action.text, "Learn More")}</span>
              </LinkButton>
            </ActionLink>
          ),
      )}
    </div>
  );
}
